import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, Col } from "react-bootstrap";
import { cloneNameToDisplay } from "../../utils/cloneNameUtils";
import { buildTranslationTextVm } from "../../utils/translationVersions/buildTranslationTextVm";
import TranslationMissingDot from "../../components/LanguageVersionSelect/TranslationMissingDot";
import { useRoleAccess } from "@me-team/host/src/utils/useRoleAccess";
import { CompanyAccess } from "@me-team/host/main/graphql/types";

interface ModalDeleteMenuItemProps {
    showDeleteModal: boolean;
    setShowDeleteModal: (show: boolean) => void;
    deleteModalMessage: string;
    handleConfirmDelete: () => void;
    itemToDeleteName: string;
    itemToDeleteNameOrigin?: string | null;
    isTranslationMode: boolean;
    canDeleteRestoreDish?: boolean;
}

const ModalDeleteMenuItem: React.FC<ModalDeleteMenuItemProps> = (props) => {
    const { t } = useTranslation();
    const canDeleteRestoreDishByRole = useRoleAccess(CompanyAccess.MenuDishDeleteRestore);
    const canSubmitDelete = props.canDeleteRestoreDish ?? canDeleteRestoreDishByRole;
    const nameVm = buildTranslationTextVm({
        translatedValue: props.itemToDeleteName,
        originValue: props.itemToDeleteNameOrigin,
        isTranslationMode: props.isTranslationMode,
    });
    return (
        <Modal centered show={props.showDeleteModal} onHide={() => props.setShowDeleteModal(false)}>
            <Modal.Header closeButton className="border-0">
                <Modal.Title className="fs-5">
                    {t("Deleting dish")} {cloneNameToDisplay(nameVm.displayText, t)}
                    {nameVm.isMissingTranslation ? (
                        <TranslationMissingDot tooltipText={t("Edit the language version")} />
                    ) : null}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mx-auto col-sm-10">
                    <p className="text-center mb-0">{props.deleteModalMessage}</p>
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Col>
                    <Button
                        variant="outline-primary"
                        className="w-100 h-100"
                        onClick={() => props.setShowDeleteModal(false)}
                    >
                        {t("cancel")}
                    </Button>
                </Col>
                <Col>
                    <Button
                        variant="primary"
                        className="w-100 fw-bold"
                        disabled={!canSubmitDelete}
                        onClick={() => {
                            if (canSubmitDelete) props.handleConfirmDelete();
                        }}
                    >
                        {t("delete")}
                    </Button>
                </Col>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalDeleteMenuItem;
